export default __webpack_public_path__ + "static/media/ttg-icon.37c7033c.webp";